/** @jsx jsx */
import { jsx } from 'theme-ui';
import Link from '../Link/Link';

export default function Button({
  onClick,
  to,
  href,
  children,
  variant = 'default',
  fallback = 'button',
  ...rest
}) {
  return (
    <Link
      onClick={onClick}
      to={to}
      href={href}
      sx={{ variant: `button.${variant}` }}
      variant="button"
      fallback={fallback}
      type="button"
      {...rest}
    >
      {children}
    </Link>
  );
}
